/**
 * CHECKOUT REAL (Impultienda). Solo el botón final de la tarjeta de oferta lleva aquí;
 * todos los demás botones desplazan a #oferta.
 *
 * Los precios de la landing son un espejo informativo (ver data/markets.ts):
 * el cobro y su importe los define exclusivamente Impultienda.
 */
export const CHECKOUT_URL = "https://de-tu-cocina-a-tus-primeros-pedidos.impultienda.ar/checkout";

export const OFFER_ANCHOR = "#oferta";

/** Precio de respaldo (mercado por defecto). Los componentes usan useLocalizedPrices(). */
export const PRICE = "USD 19.99";

export const CTA_LABEL = "Quiero empezar mi emprendimiento";
